// src/components/sensors/RegularSensorView.js
import React from 'react';
import { formatItalianTime } from '../utils/timeUtils';

const RegularSensorView = ({ sensorStats }) => {
  if (!sensorStats) {
    return (
      <div className="text-center p-3">
        <i className="bi bi-question-circle text-muted me-2"></i>
        Nessun dato disponibile
      </div>
    );
  }

  // Funzione per aggiungere un'ora a una stringa oraria
  const addOneHour = (timeStr) => {
    if (!timeStr) return 'N/A';
    
    try {
      const [hours, minutes] = timeStr.split(':').map(Number);
      const adjustedHour = (hours + 1) % 24;
      return `${adjustedHour.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    } catch (error) {
      console.error('Errore nella conversione oraria:', error);
      return 'N/A';
    }
  };

  return (
    <div className="row g-2 mb-3">
      {/* Temperatura */}
      <div className={sensorStats.hasUmidita ? "col-6" : "col-12"}>
        <div className="bg-light p-2 rounded h-100">
          <div className="d-flex justify-content-between">
            <h4 className="small fw-semibold text-muted mb-0">Temperatura</h4>
            <span className="badge bg-secondary text-white small">
              {sensorStats.lastUpdateTime
                ? formatItalianTime(sensorStats.lastUpdateTime, 'HH:mm')
                : 'N/A'}
            </span>
          </div>
          <div className="fs-1 fw-bold text-danger lh-1 my-1">
            {sensorStats.currentTemp.toFixed(1)}°
          </div>
          <div className="small text-muted lh-sm">
            <div className="d-flex justify-content-between">
              <span>
                Min: {sensorStats.tempMin.toFixed(1)}° 
                <small>
                  {sensorStats.tempMinTime 
                    ? addOneHour(sensorStats.tempMinTime) 
                    : 'N/A'}
                </small>
              </span>
              <span>
                Max: {sensorStats.tempMax.toFixed(1)}° 
                <small>
                  {sensorStats.tempMaxTime 
                    ? addOneHour(sensorStats.tempMaxTime) 
                    : 'N/A'}
                </small>
              </span>
            </div>
          </div>
        </div>
      </div>
     
      {/* Umidità - Solo se il sensore ha dati di umidità */}
      {sensorStats.hasUmidita && (
        <div className="col-6">
          <div className="bg-light p-2 rounded h-100">
            <div className="d-flex justify-content-between">
              <h4 className="small fw-semibold text-muted mb-0">Umidità</h4>
              <span className="badge bg-secondary text-white small">
                {sensorStats.lastUpdateTime
                  ? formatItalianTime(sensorStats.lastUpdateTime, 'HH:mm')
                  : 'N/A'}
              </span>
            </div>
            <div className="fs-1 fw-bold text-primary lh-1 my-1">
              {sensorStats.currentUmid.toFixed(0)}% 
            </div>
            <div className="small text-muted lh-sm">
              <div className="d-flex justify-content-between">
                <span>
                  Min: {sensorStats.umidMin.toFixed(0)}% 
                  <small>
                    {sensorStats.umidMinTime 
                      ? addOneHour(sensorStats.umidMinTime) 
                      : 'N/A'}
                  </small>
                </span>
                <span>
                  Max: {sensorStats.umidMax.toFixed(0)}% 
                  <small>
                    {sensorStats.umidMaxTime 
                      ? addOneHour(sensorStats.umidMaxTime) 
                      : 'N/A'}
                  </small>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegularSensorView;